import React from 'react';
import './Question.css'

const AnswerYes = () => {
    return <div>
        <p>
            Yes, correct, rather than describing exactly 'how' to manipulate information, 
            declarative programming allows coders to concentrate on the desired results.
        </p> 
    </div>
}

const AnswerNo = () => {
    return <div>
        <p>
            Declarative programming does indeed examine the logic of 'what' to do with 
            information.
        </p>
    </div>
}

const Answer = (props) => {
    if (props.answer === 'answerYes') {
        return <AnswerYes />
    } else if (props.answer === 'answerNo') {
        return <AnswerNo />
    } else {
        return <p>Please click an answer button above.</p>
    }
}

class QDeclara extends React.Component {
    constructor(props) {
        super(props);
        this.state = {question: 'unanswered'};
    }
    render() {
        return <div className="Question">
            <p>
                Does a declarative style focus on <em>what</em> processes to employ?
            </p>
            <br/>
            <div>
                <span className="Button Affirmative" 
                onClick={()=> this.setState({question: 'answerYes'})}
                > Yes </span>
                <span className="Button Negative"
                onClick={()=> this.setState({question: 'answerNo'})}                
                >No</span>
            </div>
            <br/>
            <Answer answer={this.state.question} />
        </div>
    }
}

export default QDeclara;


// WEBPACK FOOTER //
// ./src/components/q_declara.js